import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

const baseClass = 'validation-info'

const stateIcons = {
  empty: icons.question_mark,
  valid: icons.done,
  invalid: icons.close
}
const stateColors = {
  empty: Colors.grey,
  valid: Colors.success,
  invalid: Colors.error
}

function renderRuleIcon(h, state) {
  return h(
    components.icon,
    {
      props: {
        value: stateIcons[state],
        color: stateColors[state],
        size: 14
      }
    }
  )
}
function renderRuleLabel(h, { text, html }) {
  if (html) {
    return h(
      'span',
      {
        class: `${baseClass}__group-rule-label`,
        domProps: { innerHTML: text }
      }
    )
  }

  return h(
    'span',
    {
      class: `${baseClass}__group-rule-label`
    },
    [ text ]
  )
}
function renderRule(h, rule) {
  return h(
    'div',
    {
      class: `${baseClass}__group-rule`
    },
    [
      renderRuleIcon.call(this, h, rule.state),
      renderRuleLabel.call(this, h, rule)
    ]
  )
}
function renderRules(h, rules) {
  return h(
    'div',
    {
      class: `${baseClass}__group-rules`
    },
    rules.map(rule => {
      return renderRule.call(this, h, rule)
    })
  )
}

function renderGroupTitle(h, title) {
  if (title) {
    return h(
      'div',
      {
        class: `${baseClass}__group-title`
      },
      [ title ]
    )
  }
}
function renderGroup(h, { title, rules }) {
  return h(
    'div',
    {
      class: `${baseClass}__group`
    },
    [
      renderGroupTitle.call(this, h, title),
      renderRules.call(this, h, rules)
    ]
  )
}
function renderDivider(h) {
  return h(components.divider)
}
function renderGroups(h) {
  return this.value.reduce((result, group, index) => {
    if (index > 0) {
      result.push(renderDivider.call(this, h))
    }
    result.push(renderGroup.call(this, h, group))

    return result
  }, [])
}
function renderSlot(h) {
  return h(
    'div',
    {
      class: `${baseClass}__slot`
    },
    this.$slots.default
  )
}
function renderContent(h) {
  if (this.value.length) {
    return renderGroups.call(this, h)
  }

  return [ renderSlot.call(this, h) ]
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [baseClass]: true,
        [`${baseClass}--error`]: this.highlightInvalid && this.hasInvalidRule
      }
    },
    renderContent.call(this, h)
  )
}
